var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.11 136.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#0c0c0c;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-16,.cls-17,.cls-2,.cls-21,.cls-22,.cls-23,.cls-25,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{fill:url(#Degradado_sin_nombre_37);}.cls-2{fill:url(#Degradado_sin_nombre_37-2);}.cls-3{fill:url(#Degradado_sin_nombre_37-3);}.cls-4{fill:url(#Degradado_sin_nombre_37-4);}.cls-5{fill:url(#Degradado_sin_nombre_37-5);}.cls-6{fill:url(#Degradado_sin_nombre_37-6);}.cls-7{fill:url(#Degradado_sin_nombre_37-7);}.cls-8{fill:url(#Degradado_sin_nombre_37-8);}.cls-9{fill:url(#Degradado_sin_nombre_37-9);}.cls-10{fill:url(#Degradado_sin_nombre_37-10);}.cls-11{fill:url(#Degradado_sin_nombre_37-11);}.cls-12{fill:url(#Degradado_sin_nombre_37-12);}.cls-13{fill:url(#Degradado_sin_nombre_37-13);}.cls-14{fill:#a81616;}.cls-15{fill:#fff;}.cls-16,.cls-21,.cls-24{fill:none;}.cls-16,.cls-17,.cls-21,.cls-22,.cls-23,.cls-25{stroke:#161616;}.cls-17{fill:#e2e2e2;}.cls-18{fill:#0f0f0f;}.cls-19{fill:#bc0000;}.cls-20,.cls-25{fill:#bababa;}.cls-21,.cls-22,.cls-23,.cls-25{stroke-width:0.75px;}.cls-22{fill:#ff7878;}.cls-23{fill:#a1e9ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37",
    x1: 87.8,
    y1: 5.09,
    x2: 87.8,
    y2: 21.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff3bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ffeea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffea8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffe883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe77f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-2",
    x1: -613.9,
    y1: 30.11,
    x2: -584.72,
    y2: 30.11,
    gradientTransform: "matrix(-1, -0.01, -0.01, 1, -581.21, -16.7)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-3",
    x1: 32.67,
    y1: 3.09,
    x2: 32.67,
    y2: 19.57,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-4",
    x1: -859.79,
    y1: -634.73,
    x2: -827.96,
    y2: -634.73,
    gradientTransform: "matrix(-0.99, -0.3, 0.31, -1.01, -579.4, -882.15)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-5",
    x1: 24.79,
    y1: 129.17,
    x2: 53.97,
    y2: 129.17,
    gradientTransform: "translate(-57.5 -89.34) rotate(-15.93)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-6",
    x1: 121.42,
    y1: 140.59,
    x2: 114.73,
    y2: 164.02,
    gradientTransform: "translate(-57.5 -89.34) rotate(-15.93)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-7",
    x1: -218.59,
    y1: 530.48,
    x2: -189.41,
    y2: 530.48,
    gradientTransform: "translate(-492.18 -177.23) rotate(-90.32)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-8",
    x1: -519.44,
    y1: -162.04,
    x2: -490.26,
    y2: -162.04,
    gradientTransform: "matrix(-0.11, 0.99, -0.99, -0.11, -182.8, 516.17)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-9",
    x1: 41.85,
    y1: 19.68,
    x2: 72.64,
    y2: 19.68,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-10",
    x1: 64.83,
    y1: 15.16,
    x2: 64.44,
    y2: 35.15,
    gradientTransform: "translate(7.52 -5.96) rotate(-1.14)",
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-11",
    x1: 51.23,
    y1: 12.44,
    x2: 51.23,
    y2: 28.92,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-12",
    x1: 87.8,
    y1: 13.33,
    x2: 87.8,
    y2: 29.81,
    xlinkHref: "#Degradado_sin_nombre_37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_37-13",
    x1: 55.5,
    y1: 26.32,
    x2: 81.56,
    y2: 26.32,
    xlinkHref: "#Degradado_sin_nombre_37"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pochoclos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.78,20.84s4-1.5,2.12-7.23c0,0,.62-5.11,6.35-3.49,0,0,5.86-10.34,10.1-1.37,0,0,9.47.87,7.1,6.73C100.45,15.48,104.69,24.08,74.78,20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.73,22.46s9.57-2.64,1.18-10c0,0-8.17-5.69-7.91,3.14,0,0-8.44-13.69-14.65-2.06,0,0-7.14,9.47-.14,13.12,0,0,3.66,4,7.76.08,0,0,9.83,6.55,13.33,2.41C27.3,29.14,29,27,27.73,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.64,18.84s4-1.5,2.12-7.23c0,0,.62-5.11,6.36-3.49,0,0,5.86-10.34,10.09-1.37,0,0,9.48.87,7.11,6.73C45.32,13.48,49.56,22.08,19.64,18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.42,18.72c-1.6,3.27-10.17,6-15.05.14,0,0-13.7,7-14.47-7.63,0,0,2.45-13.09,12.5-4.5,0,0,9.55-12.85,13.72-1.64,0,0,11.51-2,8.38,5.3C77.74,12.18,74.91,15.69,73.42,18.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.92,29.39s-9.93,0-3.78-9.34c0,0,6.38-7.65,8.46.93,0,0,4.52-15.43,13.58-5.86,0,0,9.39,7.24,3.61,12.62,0,0-2.48,4.8-7.46,2.13,0,0-7.75,8.91-12.23,5.84C9.1,35.71,6.91,34.11,6.92,29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.86,29.92s-9.93,0-3.78-9.34c0,0,6.38-7.65,8.46.94,0,0,4.52-15.44,13.58-5.87,0,0,9.39,7.25,3.61,12.62,0,0-2.48,4.8-7.46,2.13,0,0-7.75,8.92-12.23,5.85C91,36.25,88.85,34.64,88.86,29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.17,33.81s-2.69,9.56-10,1.13c0,0-5.65-8.2,3.18-7.89,0,0-13.65-8.51-2-14.66,0,0,9.51-7.09,13.12-.07,0,0,4,3.67,0,7.75,0,0,6.49,9.87,2.34,13.35C48.85,33.42,46.71,35.1,42.17,33.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.31,21.13s3.74-9.2,10.08,0c0,0,4.7,8.78-4,7.48,0,0,12.61,10,.34,14.8,0,0-10.23,6-13-1.4,0,0-3.52-4.09.83-7.71,0,0-5.36-10.53-.84-13.52C23.63,20.78,25.94,19.34,30.31,21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.85,20.44s8-1.69,10.06-6.62c0,0,3.82-11.48,11.47-2.46a3.9,3.9,0,0,0,2.16,1.31c3,.66,10,3,5.79,10.29,0,0-4.64,9.14-14.09,8.45C57.24,31.41,43.22,32.1,41.85,20.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M60.12,27.42s-10-2.94,1.77-12.95c0,0,2.09,1.7,8.4-5.34a3.59,3.59,0,0,1,4.22-.87c1.8.87,4,2.34,4.87,4.57,0,0,9.73-2.22,9.74,7.56,0,0,.34,7.74-7.22,7.52a6.77,6.77,0,0,0-7.28-4.1C69.1,24.47,63.73,23.47,60.12,27.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.2,28.19s4-1.5,2.12-7.23c0,0,.63-5.11,6.36-3.49,0,0,5.86-10.35,10.09-1.37,0,0,9.48.87,7.11,6.73C63.88,22.83,68.12,31.43,38.2,28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.78,29.08s4-1.49,2.12-7.23c0,0,.62-5.11,6.35-3.49,0,0,5.86-10.34,10.1-1.37,0,0,9.47.87,7.1,6.73C100.45,23.72,104.69,32.32,74.78,29.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55.5,33.84s4-1.5,2.12-7.23c0,0,.63-5.11,6.36-3.49,0,0,5.86-10.35,10.1-1.37,0,0,9.47.87,7.1,6.73C81.18,28.48,85.42,37.08,55.5,33.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rojo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1.16,29s6-9.54,15.59-.56l17.59,107.3H25.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.9,28.51s5.69-9.65,16.11,0l3.6,34.56L37.5,62.89Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "52.61 63.07 60.24 136.21 45.97 136.21 37.5 62.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66,28.32s6.14-9.58,15.91.19l2.7,49.22L70.34,78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "70.34 78.01 74.81 136.21 87.81 136.21 84.58 77.73 70.34 78.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M97.26,28.68s5.18-10.26,13.47-.41L98.28,104.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blanco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M24.81,77.93,17,28.42s6.55-9.45,15.7-.1l6.53,49.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "44.09 119.81 45.97 136.21 34.85 136.21 24.81 77.93 39.26 77.73 42.8 104.26 44.09 119.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M49,28.51s5.89-10.27,17,.23L70.34,78,53.53,71.92Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "53.47 71.34 60.24 136.21 74.81 136.21 70.34 78.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M84.59,77.93l3.21,58.28h5.48l5-28.9-1-78.63c-9.55-10.28-15.38.24-15.38.24l1.91,34.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lineas"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M.54,28.9,25.1,136.21H93.26L110.73,28.27s-6.24-9.73-13.48.41c0,0-8.43-10.42-15.38.24,0,0-8.64-10.86-15.91-.18,0,0-9.75-10.75-17-.18,0,0-8.86-10.3-16.1,0,0,0-8.9-9.91-15.75,0C17.14,28.51,8.12,18.6.54,28.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 24.79,
    y1: 77.93,
    x2: 34.84,
    y2: 136.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 37.5,
    y1: 62.89,
    x2: 42.86,
    y2: 104.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 53.45,
    y1: 71.34,
    x2: 56.81,
    y2: 103.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 70.32,
    y1: 77.73,
    x2: 74.8,
    y2: 136.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 84.56,
    y1: 77.73,
    x2: 87.79,
    y2: 136.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 81.87,
    y1: 28.51,
    x2: 84.58,
    y2: 77.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 65.96,
    y1: 28.32,
    x2: 70.34,
    y2: 78.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 48.99,
    y1: 28.51,
    x2: 53.47,
    y2: 71.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 32.89,
    y1: 28.51,
    x2: 37.48,
    y2: 62.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 17.02,
    y1: 28.42,
    x2: 24.79,
    y2: 77.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 56.59,
    y1: 101.39,
    x2: 60.23,
    y2: 136.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 44.02,
    y1: 117.72,
    x2: 45.95,
    y2: 136.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 97.25,
    y1: 28.68,
    x2: 98.24,
    y2: 105.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boca"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M52.88,122.52a19,19,0,0,0,19-19H35.12a1.24,1.24,0,0,0-1.22,1.33A19,19,0,0,0,52.88,122.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 49.19,
    cy: 116.16,
    rx: 3.31,
    ry: 7.67,
    transform: "translate(-75.91 132.38) rotate(-74.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lentes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M23.31,76.72V63.66a.8.8,0,0,1,.8-.8H88.32a.8.8,0,0,1,.8.8V76.72a.8.8,0,0,1-.8.8H65.19a.8.8,0,0,1-.67-.37L60.91,71.5a.79.79,0,0,0-.67-.37H52.09a.78.78,0,0,0-.68.38L48,77.13a.79.79,0,0,1-.68.39H24.11A.8.8,0,0,1,23.31,76.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M23.31,76.5V63.66a.8.8,0,0,1,.8-.8H88.32a.8.8,0,0,1,.8.8V76.53a1,1,0,0,1-1,1H65.19a.8.8,0,0,1-.67-.37L60.91,71.5a.79.79,0,0,0-.67-.37H52.09a.78.78,0,0,0-.68.38L48,77.13a.79.79,0,0,1-.68.39h-23A1,1,0,0,1,23.31,76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M26.22,74.81V66a.8.8,0,0,1,.8-.8H48.24a.8.8,0,0,1,.8.8v4.3a.87.87,0,0,1-.15.47l-3.21,4.49a.79.79,0,0,1-.65.33H27A.79.79,0,0,1,26.22,74.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M86.17,74.74V65.85a.8.8,0,0,0-.8-.8H63.55a.8.8,0,0,0-.8.8V70.2a.8.8,0,0,0,.15.47l3.3,4.54a.79.79,0,0,0,.65.33H85.37A.79.79,0,0,0,86.17,74.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M89.12,77.52l15.67-7.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "23.31 76.12 10.18 71.04 7.4 58.88 23.31 64.32 23.31 76.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "89.29 76.12 103.79 71.04 105.75 58.88 89.29 64.32 89.29 76.12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2f7987c62de2da5941c55ec1c44fa126.svg";
export { ForwardRef as ReactComponent };